exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-btn--full[data-v-023fa533] {\n  width: 100% !important;\n  border-radius: 50px;\n}\n.c-btn--full[data-v-023fa533]:hover {\n background-color:  #e3e3e3;\n}\n@media screen and (min-width: 896px) {\n.c-btn--narrow[data-v-023fa533] {\n    min-width: inherit;\n    padding: 11px 60px;\n    text-align: left;\n}\n}\n@media screen and (max-width: 895px) {\n.c-btn--narrow[data-v-023fa533] {\n    font-size: 3.73333vw;\n    padding: 1.33333vw 0vw;\n    width: 100%;\n}\n}\n", ""]);

// exports
